var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseErrorPanelRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6093 10.5521C13.349 10.2918 13.349 9.86967 13.6093 9.60932C13.8697 9.34898 14.2918 9.34898 14.5521 9.60932L19.9998 15.057L25.4476 9.60932C25.7079 9.34898 26.13 9.34898 26.3904 9.60932C26.6507 9.86967 26.6507 10.2918 26.3904 10.5521L20.9427 15.9998L26.3904 21.4476C26.6507 21.7079 26.6507 22.13 26.3904 22.3904C26.13 22.6507 25.7079 22.6507 25.4476 22.3904L19.9998 16.9427L14.5521 22.3904C14.2918 22.6507 13.8697 22.6507 13.6093 22.3904C13.349 22.13 13.349 21.7079 13.6093 21.4476L19.057 15.9998L13.6093 10.5521Z",
    fill: "#C52A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseErrorPanelRed);
export default __webpack_public_path__ + "static/media/icon_close_error_panel_red.2686de183016f3f0cbb56c61a3abddcc.svg";
export { ForwardRef as ReactComponent };